import React from 'react';
import styled from 'styled-components';
import FlexboxList from "./FlexboxList";
import { fontUbuntuLight } from '../../utilities/utilities';

const FAQTerm = styled.dt`
  color: ${props => props.textColor ? props.textColor : 'inherit'};
  font-size: 1.1625em;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  font-weight: 700;
`

const FAQDescription = styled.dd`
  margin-bottom: 2rem;
  color: ${props => props.textColor ? props.textColor : 'inherit'};
  font-size: 1.1925em;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  font-weight: ${ props => props.bold ? 700 : 500 };
`

const FAQDescriptionList = styled.dl`
  color: ${props => props.textColor ? props.textColor : '#0d1b58'};
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
`
const FAQSpan = styled.span`
  color: ${props => props.textColor ? props.textColor : '#inherit'};
  font-size: 1.0625em;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  font-weight: ${ props => props.bold ? 700 : 500 };
  display: ${ props => props.inline ? 'inline-block' : 'block' };
`
const FAQWordList = styled.ul`
    /* list-style: none; */
    margin-top: 0.5rem;
    margin-left: 3rem;
`;
const FAQWordListItem = styled.li`
    font-weight: ${ props => props.bold ? 700 : 500 };
    margin-bottom:0.5rem;
`;

const FlexBox = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 2rem;
    color: ${props => props.textColor ? props.textColor : '#0d1b58'};
`
// const FlexItem = styled.div`
//     flex: 1 1 auto;
//     text-align: ${ props => props.right ? 'right' : 'left' };
//     margin-bottom: 1rem;
// `
const FaqsPoint = (props) => {

    let FaqsPointitem =  Object.keys(props.list).map((element, index) => {
        let options;
        let image;
        //let FlexList;
        if(props.list[element].list){
            options = Object.keys(props.list[element].list.options).map((option, index) =>{
                return <FAQWordListItem>{props.list[element].list.options[option]}</FAQWordListItem>
            })
        }
        if(props.list[element].img){
            image= <img src={props.list[element].img.uri} alt=''/>
            if(props.list[element].img.href){
                image = <a href={props.list[element].img.href} target="_blank">{image}</a>;
            }
        }





        return  <div>
            <FAQTerm>{props.list[element].title}</FAQTerm>
            <FAQDescription>
                {props.list[element].text}
                {props.list[element].list?
                <div><FAQSpan>{props.list[element].list.title}</FAQSpan><FAQWordList> {options} </FAQWordList></div>:''}
                {props.list[element].img? <div>{image}</div>:''}
            </FAQDescription>
        </div>



    });

    let FaqsFlex = Object.keys(props.list).map((element, index) => {
        let FlexList;
        if(props.list[element].type === "flexbox"){
            FlexList = <FlexboxList list={props.list[element]} appState={props.appState} />;
        }
        return FlexList;
    });

    return (<div>
            <FAQDescriptionList>
                {FaqsPointitem}
            </FAQDescriptionList>
            <FlexBox>
                {FaqsFlex}
            </FlexBox>
        </div>

    )
}

export default FaqsPoint;


// WEBPACK FOOTER //
// ./src/components/Lists/FaqsPoint.js